import type { AppScenario } from './build.ts';
import { contentScenarios } from './content.ts';
import { managerScenarios } from './manager.ts';
import { sellerScenarios } from './seller.ts';

export type { AppScenario } from './build.ts';

/** Every scenario of the layout lab, in the order the lab shows them. */
export const APP_SCENARIOS: AppScenario[] = [...sellerScenarios, ...managerScenarios, ...contentScenarios];
